export default __webpack_public_path__ + "static/media/feature-monitoring-3.dfd66785.png";